module.exports = __webpack_public_path__ + "img/imgLogin.a53356a1.png";